export const applicationKeys = {
  application: "application",
  translations: "translations"
};
